var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLockMulticolourLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-lock-multicolour-light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-1456, -889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Multi-color",
    transform: "translate(1120, 279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-11",
    transform: "translate(0, 610)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/lock/Multicolour/Light",
    transform: "translate(338.5, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2857143,8.25 C17.7828125,8.25 19,9.48320312 19,11 L19,19.25 C19,20.7667969 17.7828125,22 16.2857143,22 L2.71428571,22 C1.21506696,22 0,20.7667969 0,19.25 L0,11 C0,9.48320312 1.21506696,8.25 2.71428571,8.25 L16.2857143,8.25 Z M10.8571429,13.75 C10.8571429,12.9894531 10.2506696,12.375 9.5,12.375 C8.74933036,12.375 8.14285714,12.9894531 8.14285714,13.75 L8.14285714,16.5 C8.14285714,17.2605469 8.74933036,17.875 9.5,17.875 C10.2506696,17.875 10.8571429,17.2605469 10.8571429,16.5 L10.8571429,13.75 Z",
    id: "Primary",
    fill: "#4C69BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,2.75 C7.62544643,2.75 6.10714286,4.28914062 6.10714286,6.1875 L6.10714286,8.25 L3.39285714,8.25 L3.39285714,6.1875 C3.39285714,2.77019531 6.12834821,0 9.5,0 C12.8716518,0 15.6071429,2.77019531 15.6071429,6.1875 L15.6071429,8.25 L12.8928571,8.25 L12.8928571,6.1875 C12.8928571,4.28914062 11.3745536,2.75 9.5,2.75 Z",
    id: "Secondary",
    fill: "#98A6D6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockMulticolourLight);
export default __webpack_public_path__ + "static/media/icon-lock-multicolour-light.e723bd36.svg";
export { ForwardRef as ReactComponent };